import React, { useState, useEffect, forwardRef } from "react";
import urls from "../../constants";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import FetchData from "../../providers/dataProvider";

const DistributorPayment = (props) => {
    const {
        setValues,
        values,
        errors,
        setErrors
    } = props;
    const { data: paymentTermsData } = FetchData("paymentterms");
    const { data: deliveryTermsData } = FetchData("deliveryterms");

    const [paymentTerms, setPaymentTerms] = useState(null);
    const [paymentTermsList, setPaymentTermsList] = useState([]);
    const [payTermsList, setPayTermsList] = useState([]);

    const [deliveryTerms, setDeliveryTerms] = useState(null);
    const [deliveryTermsList, setDeliveryTermsList] = useState([]);
    const [delTermsList, setDelTermsList] = useState([]);

    useEffect(() => {
        setPayTermsList(paymentTermsData)
    }, [paymentTermsData])

    useEffect(() => {
        setDelTermsList(deliveryTermsData)
    }, [deliveryTermsData])

    const HandlePaymentTermsChange = (selectedOption) => {
        setPaymentTerms(selectedOption);
    };

    const PaymentAddToList = (termToAdd = paymentTerms) => {
        if (termToAdd?.value !== undefined && termToAdd?.value !== null && termToAdd?.label) {
            const updatedTerms = [...paymentTermsList, termToAdd];
            setPaymentTermsList(updatedTerms);
            setValues((prevValue) => ({
                ...prevValue,
                distributorPaymentTerms: updatedTerms.map((term) => ({
                    distributorId: prevValue?.id || "",
                    paymentTermId: term.value,
                })),
            }));
            setErrors?.((prevErrors) => {
                const { distributorPaymentTerms, ...remainingErrors } = prevErrors;
                return remainingErrors;
            });
            setPaymentTerms(null);
        }
    }

    useEffect(() => {
        const termsTemp = paymentTermsList?.map((element, index) => ({
            distributorId: values?.id ? values?.id : "",
            paymentTermId: element.value,
        }))
        setValues((prevValue) => ({ ...prevValue, distributorPaymentTerms: termsTemp }))
    }, [paymentTermsList])

    useEffect(() => {
        if (!paymentTermsData || !values?.editpaymentTerms) return;
        const termsTemp = values?.editpaymentTerms?.map((element, index) => ({
            label: paymentTermsData?.find((item) => item.id === element.paymentTermId)?.paymentDescription,
            value: element.paymentTermId,
        }))
        setPaymentTermsList(termsTemp)
    }, [values?.editpaymentTerms, paymentTermsData])

    useEffect(() => {
        let checkList = paymentTermsData;
        if (paymentTermsList?.length > 0) {
            checkList = paymentTermsData?.filter(
                (item) =>
                    !paymentTermsList
                        ?.map((element, index) => {
                            return element.value;
                        })
                        .includes(item.id)
            );
        }
        setPayTermsList(checkList);
    }, [paymentTermsList, paymentTermsData]);

    const DeletePaymentTerm = (value) => {
        const filterPaymentTerm = paymentTermsList?.filter(item => item.value !== value)
        setPaymentTermsList(filterPaymentTerm);
    }

    const HandleDeliveryTermsChange = (selectedOption) => {
        setDeliveryTerms(selectedOption);
    };

    const DeliveryAddToList = (termToAdd = deliveryTerms) => {
        if (termToAdd?.value !== undefined && termToAdd?.value !== null && termToAdd?.label) {
            const updatedTerms = [...deliveryTermsList, termToAdd];
            setDeliveryTermsList(updatedTerms);
            setValues((prevValue) => ({
                ...prevValue,
                distributorDeliveryTerms: updatedTerms.map((term) => ({
                    distributorId: prevValue?.id || "",
                    deliveryTermId: term.value,
                })),
            }));
            setErrors?.((prevErrors) => {
                const { distributorDeliveryTerms, ...remainingErrors } = prevErrors;
                return remainingErrors;
            });
            setDeliveryTerms(null);
        }
    }

    useEffect(() => {
        const termsTemp = deliveryTermsList?.map((element, index) => ({
            distributorId: values?.id ? values?.id : "",
            deliveryTermId: element.value,
        }))

        setValues((prevValue) => ({ ...prevValue, distributorDeliveryTerms: termsTemp }))
    }, [deliveryTermsList])

    useEffect(() => {
        if (!deliveryTermsData || !values?.editDeliveryTerms) return;
        const termsTemp = values?.editDeliveryTerms?.map((element, index) => ({
            label: deliveryTermsData?.find((item) => item.id === element.deliveryTermId)?.deliveryDescription,
            value: element.deliveryTermId,
        }))
        setDeliveryTermsList(termsTemp)
    }, [values?.editDeliveryTerms, deliveryTermsData])

    useEffect(() => {
        let checkList = deliveryTermsData;
        if (deliveryTermsList?.length > 0) {
            checkList = deliveryTermsData?.filter(
                (item) =>
                    !deliveryTermsList
                        ?.map((element, index) => {
                            return element.value;
                        })
                        .includes(item.id)
            );
        }
        setDelTermsList(checkList);
    }, [deliveryTermsList, deliveryTermsData]);


    const DeleteDeliveryTerm = (value) => {
        const filterDeliveryTerm = deliveryTermsList?.filter(item => item.value !== value)
        setDeliveryTermsList(filterDeliveryTerm);
    }

    return (
        <>
            <div className="card payment-card mb-2">
                <div className="card-header">
                    <h2>Payment Terms</h2>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="card w-100 mb-2">
                                <div className="card-body p-0">
                                    <div className="row distributor-terms-row">
                                        <div className="col-xxl-10 col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                            <div>
                                                <label>Payment Terms</label>
                                                <DropDownComponent
                                                    isDisabled={false}
                                                    placeHolder={PlaceHolder.SELECT_PAYMENT_TERMS}
                                                    pageName="distributor"
                                                    dpDownName="paymentterms"
                                                    stateData={payTermsList}
                                                    controlName="paymentterms"
                                                    handleChange={HandlePaymentTermsChange}
                                                    value={paymentTerms}
                                                    valueId={paymentTerms?.value}
                                                    setState={setPaymentTerms}
                                                    multiSelect={false}
                                                />
                                            </div>
                                        {errors.distributorPaymentTerms && (
                                                <p className="form-error">{errors.distributorPaymentTerms}</p>
                                            )}
                                        </div>
                                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mt-3">
                                            <div className="mt-9px">
                                                <button
                                                    type="button"
                                                    className="btn add-btn"
                                                    onClick={() => PaymentAddToList()}
                                                >
                                                    Add to list
                                                </button>
                                            </div>
                                        </div>
                                        {paymentTermsList?.length > 0 && (
                                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 distributor-terms-table">
                                                <table className="table table-striped table-borderless mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Sl#.</th>
                                                            <th scope="col">Payment Term</th>
                                                            <th scope="col" className="text-center"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {paymentTermsList?.map((item, index) => {
                                                            return (
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.label}</td>
                                                                    <td className="text-center">
                                                                        <span>
                                                                            <i
                                                                                className="far fa-trash-alt"
                                                                                onClick={() => {
                                                                                    DeletePaymentTerm(item.value);
                                                                                }}
                                                                                title="Delete"
                                                                            ></i>
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card delivery-card mb-2">
                <div className="card-header">
                    <h2>Delivery Terms</h2>
                </div>
                <div className="card-body pb-3">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="card w-100 mb-2">
                                <div className="card-body p-0">
                                    <div className="row distributor-terms-row">
                                        <div className="col-xxl-10 col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                            <div>
                                                <label>Delivery Terms</label>
                                                <DropDownComponent
                                                    isDisabled={false}
                                                    placeHolder={PlaceHolder.SELECT_DELIVERY_TERMS}
                                                    pageName="distributor"
                                                    dpDownName="deliveryterms"
                                                    stateData={delTermsList}
                                                    controlName="deliveryterms"
                                                    handleChange={HandleDeliveryTermsChange}
                                                    value={deliveryTerms}
                                                    valueId={deliveryTerms?.value}
                                                    setState={setDeliveryTerms}
                                                    multiSelect={false}
                                                />
                                            </div>
                                        {errors.distributorDeliveryTerms && (
                                            <p className="form-error">{errors.distributorDeliveryTerms}</p>
                                        )}
                                        </div>
                                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mt-3">
                                            <div className="mt-9px">
                                                <button
                                                    type="button"
                                                    className="btn add-btn"
                                                    onClick={() => DeliveryAddToList()}
                                                >
                                                    Add to list
                                                </button>
                                            </div>
                                        </div>
                                        {deliveryTermsList?.length > 0 && (
                                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 distributor-terms-table">
                                                <table className="table table-striped table-borderless mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Sl#.</th>
                                                            <th scope="col">Delivery Term</th>
                                                            <th scope="col" className="text-center"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {deliveryTermsList?.map((item, index) => {
                                                            return (
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.label}</td>
                                                                    <td className="text-center">
                                                                        <span>
                                                                            <i
                                                                                className="far fa-trash-alt"
                                                                                onClick={() => {
                                                                                    DeleteDeliveryTerm(item.value);
                                                                                }}
                                                                                title="Delete"
                                                                            ></i>
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DistributorPayment;
